module.exports = __webpack_public_path__ + "img/en.1d018fbb.png";